import React, { createContext, useContext, useState, useEffect } from 'react';
import { loginUser, registerUser } from '../api/endpoint/apiService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const email = localStorage.getItem('user_email');
    const role = localStorage.getItem('user_role');
    const status = localStorage.getItem('user_status');
    const id = localStorage.getItem('user_id') || localStorage.getItem('userId');

    if (token && email && token !== 'undefined') {
      const currentUser = { id, email, role, status };
      setUser(currentUser);
      console.log("Current authenticated user (on mount):", currentUser);
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    setError(null);
    try {
      const data = await loginUser(email, password);
      console.log('LOGIN RESPONSE USER:', data);
      const payload = data.data || data;

      const userObj = {
        id: payload.user?.id || payload.id || payload.user_id || payload.userId || payload.user?.user_id || data.user_id || data.id || data.userId || payload.user?.userId,
        email: payload.user?.email || payload.email || email,
        role: payload.role || payload.user?.role || 'USER',
        status: payload.status || payload.user?.status || 'APPROVED',
      };
      console.log('AUTH USER:', userObj);

      const token = payload.accessToken || payload.token || data.token;

      if (userObj.id) {
        localStorage.setItem('user_id', userObj.id);
        localStorage.setItem('userId', userObj.id);
      }
      localStorage.setItem('token', token);
      localStorage.setItem('user_email', userObj.email);
      localStorage.setItem('user_role', userObj.role);
      localStorage.setItem('user_status', userObj.status);

      setUser(userObj);
      setLoading(false);
      return userObj;
    } catch (err) {
      setError(err.message || 'Login failed');
      setLoading(false);
      throw err;
    }
  };

  const register = async (email, password, role = 'USER') => {
    setLoading(true);
    setError(null);
    try {
      const data = await registerUser(email, password, role);
      setLoading(false);
      return data;
    } catch (err) {
      setError(err.message || 'Registration failed');
      setLoading(false);
      throw err;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_role');
    localStorage.removeItem('user_status');
    localStorage.removeItem('user_id');
    localStorage.removeItem('userId');
    setUser(null);
    console.log("Logout: cleared all cached user data.");
  };

  const updateStatus = (newStatus) => {
    localStorage.setItem('user_status', newStatus);
    setUser(prev => prev ? { ...prev, status: newStatus } : null);
  };

  const isAuthenticated = !!user && localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined';
  const isPending = user?.role?.toUpperCase() !== 'ADMIN' && user?.status?.toUpperCase() === 'PENDING';
  const isRejected = user?.role?.toUpperCase() !== 'ADMIN' && user?.status?.toUpperCase() === 'REJECTED';
  const isApproved = user?.role?.toUpperCase() === 'ADMIN' || user?.status?.toUpperCase() === 'APPROVED';
  const isBlocked = user?.role?.toUpperCase() !== 'ADMIN' && user?.status?.toUpperCase() === 'BLOCKED';

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        error,
        login,
        register,
        logout,
        updateStatus,
        isAuthenticated,
        isPending,
        isRejected,
        isApproved,
        isBlocked,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
